import styled from 'styled-components';

import { effects } from '/css';
import IconButton from './buttons/IconButton';
import Icon from './Icon';
import Editable from '/components/Editable';

export interface NumberInputProps {
    className?: string;
    style?: React.CSSProperties;
    name: string;
    onChange: (val: number) => void;
    value: number;
    minValue: number;
    maxValue: number;
    label?: string;
}

export default function NumberInput({
    className,
    style,
    name,
    onChange,
    value,
    minValue = 1,
    maxValue = 100,
    label,
}: Readonly<NumberInputProps>) {
    const id = 'ni-' + name;

    return (
        <Wrapper
            className={['number-input', className || ''].join(' ')}
            style={style}
        >
            <input
                type="number"
                id={id}
                name={name}
                value={value}
                onChange={() => null}
                className="hidden-input"
            />
            <div className="counter">
                <IconButton
                    className={[
                        'minus',
                        value === minValue ? 'disabled' : '',
                    ].join(' ')}
                    onClick={() =>
                        onChange(value > minValue ? value - 1 : minValue)
                    }
                    icon={<Icon icon="subtract" fill="#fff" />}
                    size="small"
                    disabled={value === minValue}
                />
                <Editable
                    value={String(value)}
                    onChange={(v: string) => {
                        let val = Number(v.replace(/\D/g, ''));
                        if (val > maxValue) val = maxValue;
                        if (val < minValue) val = minValue;
                        onChange(val);
                    }}
                    outlined={false}
                    className="heading-small editable-label"
                />
                <IconButton
                    className={[
                        'plus',
                        value === maxValue ? 'disabled' : '',
                    ].join(' ')}
                    onClick={() =>
                        onChange(value < maxValue ? value + 1 : maxValue)
                    }
                    icon={<Icon icon="add" fill="#fff" />}
                    size="small"
                    disabled={value === maxValue}
                />
            </div>
            {label && <label htmlFor={id}>{label}</label>}
        </Wrapper>
    );
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    width: 214px;

    .hidden-input {
        visibility: hidden;
        opacity: 0;
        position: absolute;
    }

    .counter {
        display: flex;
        align-items: center;
        height: 64px;
        background: #fff;
        border-radius: 12px;
        ${effects.shadow};
        padding: 14px 16px;
        width: 100%;
        .minus,
        .plus {
            min-width: 40px;
            border: none;
        }
        .editable-label {
            width: 100%;
            textarea {
                text-align: center;
                font-size: 24px;
            }
        }
    }
    label {
        font-size: 17px;
        font-family: 'gellix-semi';
        margin-bottom: 8px;
        padding-top: 3px;
        padding-right: 24px;
        display: inline-block;
    }
`;
